export default __webpack_public_path__ + "static/media/whitepaperFrench.7437e343.pdf";